import { render, staticRenderFns } from "./Simulations.vue?vue&type=template&id=3466fd3b&scoped=true"
import script from "./Simulations.vue?vue&type=script&lang=js"
export * from "./Simulations.vue?vue&type=script&lang=js"
import style0 from "./Simulations.vue?vue&type=style&index=0&id=3466fd3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3466fd3b",
  null
  
)

export default component.exports